import { render } from "./SingleProduct.vue?vue&type=template&id=63926248&scoped=true"
import script from "./SingleProduct.vue?vue&type=script&lang=js"
export * from "./SingleProduct.vue?vue&type=script&lang=js"

import "./SingleProduct.vue?vue&type=style&index=0&id=63926248&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63926248"

export default script